import script from "./ImageCarouselModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCarouselModal.vue?vue&type=script&setup=true&lang=js"

import "./ImageCarouselModal.vue?vue&type=style&index=0&id=2ff86ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff86ed6"]])

export default __exports__